import { useContext } from "react";
import DynamicForm from "./dynamicForm.Component";
import { FormContext } from "../../context/form.context";

const FormModal = ({ initialValues={} }) => {
    const { setIsFormOpen, isFormOpen, formType, updateFormdata } = useContext(FormContext);

    const CloseForm = () => {
        setIsFormOpen(false);
        updateFormdata({});
    }

    return (
        <>
            {
                isFormOpen &&
                <div className="admin__content-form">
                    <div className="admin__content-form--overlay"></div>
                    <div className="admin__content-form--container">
                        <span className="admin__content-form--close" onClick={() => CloseForm()}>&times;</span>
                        <DynamicForm formType={formType} title= {`Add ${formType}`} initialValues={initialValues} />
                    </div>
                </div>
            }
        </>
    )
};

export default FormModal;